// 7.2E3-C — minimal commercial-clarity chip. Derived purely from existing 7.2E3-B gate
// fields (shipment.insurance_status, shipment.air12_payment_status). One status at a time.
// Hidden for legacy shipments that have no Air12 commercial gate (both fields null).

const TONE = {
  ok: "text-[hsl(var(--accent))] border-[hsl(var(--accent)/0.45)] bg-[hsl(var(--info-bg))]",
  warn: "text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.45)]",
  bad: "text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.45)]",
};

function chipFor(shipment, role, hasSubmittedInsurance) {
  const insConfirmed = shipment.insurance_status === "CONFIRMED";
  const payCompleted = shipment.air12_payment_status === "COMPLETED";

  if (role === "SENDER") {
    if (insConfirmed && payCompleted) return { label: "Commercial clearance complete", tone: "ok" };
    if (insConfirmed) return { label: "Air12 payment due", tone: "warn" };
    return {
      label: "Insurance required", tone: "warn",
      title: "Air12 payment is locked until cargo insurance is confirmed",
    };
  }
  // admin / CTOP
  if (insConfirmed && payCompleted) return { label: "Commercially clear", tone: "ok" };
  if (shipment.air12_payment_status === "PENDING") return { label: "Air12 payment action required", tone: "warn" };
  if (hasSubmittedInsurance && shipment.insurance_status === "PENDING") return { label: "Insurance action required", tone: "warn" };
  return { label: "Commercially blocked", tone: "bad" };
}

export function CommercialChip({ shipment, role, hasSubmittedInsurance = false, className = "" }) {
  if (!shipment) return null;
  if (!shipment.insurance_status && !shipment.air12_payment_status) return null; // legacy / no gate
  const { label, tone, title } = chipFor(shipment, role, hasSubmittedInsurance);
  return (
    <span
      title={title}
      data-testid="commercial-chip"
      className={`inline-flex items-center px-2 py-0.5 rounded-[2px] border text-[11px] font-semibold whitespace-nowrap ${TONE[tone]} ${className}`}
    >
      {label}
    </span>
  );
}
